import _ from 'lodash';
import { t } from 'ttag';

const ETHNICITY = {
  AFRICAN: t`African`,
  AFRICAN_AMERICAN: t`African American`,
  AMERICAN: t`American Indian or Alaska Native`,
  ASIAN: t`Asian`,
  CAUCASIAN: t`Caucasian`,
  HISPANIC_LATINO: t`Hispanic or Latino`,
  MIDDLE_EASTERN: t`Middle Eastern`,
  NATIVE_HAWAIIAN: t`Native Hawaiian or Other Pacific Islander`,
  NORTH_AFRICAN: t`North African`,
};

/**
 * Select options derived from the ETHNICITY list. Maps every ethnicity entry into a `{ label, value }` pair that reuses the same string for both fields.
 *
 * @returns One option per ethnicity, label and value identical.
 */
const ETHNICITY_OPTIONS = _.map(ETHNICITY, (item) => ({ label: item, value: item }));

export { ETHNICITY, ETHNICITY_OPTIONS };
